import React, { useEffect, useState, useCallback } from 'react';
import { USER_ICON, EYE_ICON, EYE_SLASH_ICON } from "assets/constants/Icons";
import { SECRET_KEY, PHONE_NUMBER_PATTERN, emailPattern, passwordMatchPattern, TYPE_SUCCESS, TYPE_FAIL, TYPE_INFO, INTERVAL } from "assets/constants/Constants";
import md5 from 'md5';
import Spinner from 'components/Spinner';
import CryptoJS from "crypto-js";
import ShowToast from 'components/ShowToast';
import Select from 'react-select';
import { fetchMetadata, toCapitaliseWord } from 'lib/utils';
import { getRoleListCall, getPartnerList, getEmployerList, createUserCall, UpdateUserCall, getUserList } from "lib/axiosUtils";

const CreateUserPage = (props) => {
    const editData = props.history?.location?.state;
    const [isLoading, setIsLoading] = useState(true);
    const [isUsernamePresent, setIsUsernamePresent] = useState(false);
    const [error, setError] = useState({});
    const [userId] = useState(editData ? editData._id : null);
    const [firstName, setFirstName] = useState(editData?.first_name || "");
    const [lastName, setLastName] = useState(editData?.last_name || "");
    const [emailId, setEmailId] = useState(editData?.email_id || "");
    const [phoneNumber, setPhoneNumber] = useState(editData?.phone_number || "");
    const [userName, setUserName] = useState(editData?.username || "");
    const [password, setPassword] = useState(editData?.password || "");
    const [confirmPassword, setConfirmPassword] = useState(editData?.password || "");
    const userType = useState(editData?.userType || "");
    const isFromProfile = editData ? editData.isFromProfile : "";
    const auditflag = editData ? editData.audit_enable : false;
    const userdetails = JSON.parse(localStorage.getItem("userData"));
    const [roleListComponent, setRoleListComponent] = useState([]);
    const [setTrainingPartnerComponent, setSetTrainingPartnerComponent] = useState("<option> Training Partner List </option>");
    const [profileOptions] = useState([
        { value: 'employer', label: 'Employer' },
        { value: 'training partner', label: 'Training Partner' },
    ]);
    const [userRole, setUserRole] = useState(editData ? editData.role : "");

    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [partnerList, setPartnerList] = useState([]);
    const [selectedPartnerList, setSelectedPartnerList] = useState([]);
    const [userList, setUserList] = useState([]);
    const [setDisableEmployerUnit, setSetDisableEmployerUnit] = useState(true);
    const [employerUnitComponent, setEmployerUnitComponent] = useState("");
    const [employerListComponent, setEmployerListComponent] = useState("");
    const [roleList, setRoleList] = useState([]);
    const [selectedTrainingPartner, setSelectedTrainingPartner] = useState(editData ? editData.partner_id ? { value: editData.partner_id, label: editData.partner_id } : null : null);
    const [setDisableTrainingPartner, setSetDisableTrainingPartner] = useState(true);
    const [employerList, setEmployerList] = useState([]);
    const [selectedPartner, setSelectedPartner] = useState(editData ? editData.partner_id ? { value: editData.partner_id, label: editData.partner_id } : null : null);
    const [employerUnit, setEmployerUnit] = useState(editData ? editData.employer_id ? { value: editData.employer_id, label: editData.employer_id } : null : null);
    const [selectedEmployer, setSelectedEmployer] = useState(editData ? editData.company_id ? { value: editData.company_id, label: editData.company_id } : null : null);
    const [selectProfile, setSelectProfile] = useState(editData && editData.select_profile ? { value: editData.select_profile, label: editData.select_profile } : "");

    const setListComponent = useCallback(async () => {
        let metaData = JSON.parse(localStorage.getItem("metadata")) ? JSON.parse(localStorage.getItem("metadata")) : [];
        if (metaData && metaData.length === 0) {
            metaData = await fetchMetadata();
        }
        const companyMetaData = metaData[0].meta_data.companies;
        const listComponent = companyMetaData.map((item) => {
            if (props.location.state) {
                if (props.location.state.company_id === item.company_id) {
                    setSelectedEmployer({ label: item.company_name, value: item.company_id });
                }
            }
            return { label: item.company_name, value: item.company_id }
        });
        setEmployerListComponent(listComponent);
    }, [props.location.state])

    const fetchEmployerList = useCallback(async () => {
        try {
            const data = await getEmployerList({}, {});
            const employerList = data.data.result;
            setEmployerList(employerList);

            employerList.forEach((item) => {
                if (employerUnit) {
                    if (item._id === employerUnit.value) {
                        setEmployerUnit({ label: item.unit_name, value: item._id });
                    }
                }
            });
            setListComponent();
        }
        catch (error) {
            console.log("error while fetching data", error);
        }
    }, [employerUnit, setListComponent])

    const fetchPartnerList = useCallback(async () => {
        try {
            const response = await getPartnerList({}, {});
            const partnerList = response.data.result;
            setPartnerList(partnerList);

            partnerList.forEach((item) => {
                if (selectedPartner) {
                    if (item._id === selectedPartner.value) {
                        setSelectedPartner({ label: item.partner_name, value: item.partner_name.toLocaleLowerCase() });
                        if (item.partner_name === "TIMES-PRO") {
                            setSetDisableTrainingPartner(true);
                            setSelectedTrainingPartner(null);
                        }
                    }
                }

                if (selectedTrainingPartner) {
                    if (item._id === selectedTrainingPartner.value) {
                        setSelectedTrainingPartner({
                            label: item.training_partner,
                            value: item._id
                        });
                    }
                }
            });
            return response;
        }
        catch (error) {
            console.log("Error Occurred while fetching training partner list", error);
        }
    }, [selectedPartner, selectedTrainingPartner])

    useEffect(() => {
        const fetchData = async () => {
            try {
                const [roleData, partnerData, userListData] = await Promise.all([
                    getRoleListCall({}, {}),
                    fetchPartnerList(),
                    getUserList({}, {})
                ]);

                setRoleList(roleData.data.result);
                setPartnerList(partnerData.data.result);
                setUserList(userListData.data.result);
                setIsLoading(false);
                PartnerComponent(partnerData.data.result);
                setListComponent();
                fetchEmployerList();
            } catch (error) {
                console.error("Error fetching data:", error);
                setIsLoading(false);
            }
        };

        fetchData();
    }, [fetchEmployerList, fetchPartnerList, setListComponent]);

    const setUserRoleComponent = useCallback(() => {
        if (roleList.length > 0) {
            const listComponent = roleList.map((item) => {
                if (userRole) {
                    if (userRole === item._id) {
                        setUserRole({ label: toCapitaliseWord(item.user_role), value: item._id });
                    }
                }
                return { label: toCapitaliseWord(item.user_role), value: item._id }
            })
            setRoleListComponent(listComponent);
        }
    }, [userRole, roleList])

    useEffect(() => {
        if (roleList && roleList.length > 0) {
            setUserRoleComponent();
        }
    }, [roleList, setUserRoleComponent]);

    const PartnerComponent = async () => {
        let listComponent = ["THSC", "TIMES-PRO"];

        listComponent = listComponent.map((item) => {
            return { label: item, value: item.toLocaleLowerCase() };
        });

        setSelectedPartnerList(listComponent);
    };

    const firstNameChangeHandler = (event) => {
        setFirstName(event.target.value);
    }

    const lastNameChangeHandler = (event) => {
        setLastName(event.target.value);
    }

    const emailIdChangeHandler = (event) => {
        setEmailId(event.target.value);
    }

    const phoneNumberChangeHandler = (event) => {
        setPhoneNumber(event.target.value);
    }

    const userNameChangeHandler = (event) => {
        setUserName(event.target.value);
    }

    const passwordChangehandler = (event) => {
        setPassword(event.target.value);
    }

    const confirmPasswordChangehandler = (event) => {
        setConfirmPassword(event.target.value);
    }

    const handleShowPasswordClick = (event) => {
        if (!userId) {
            setShowPassword(!showPassword);
        }
    };

    const handleShowConfirmPasswordClick = (event) => {
        if (!userId) {
            setShowConfirmPassword(!showConfirmPassword)
        }
    }

    const emailUniqueHandler = (event) => {
        if (event.target.value) {
            if (!userId) {
                const userFound = userList.find((findItem) => findItem.email_id.trim().toLowerCase() === event.target.value.trim().toLowerCase())
                if (userFound) {
                    ShowToast('Email Id already present, please try with different email id!', TYPE_FAIL, INTERVAL, "", "");
                    setEmailId("");
                }
            }
        }
    }

    const usernameUniqueHandler = async (event) => {
        if (event.target.value) {
            if (!userId) {
                const userFound = userList.find((findItem) => findItem.username.trim().toLowerCase() === event.target.value.trim().toLowerCase())
                if (userFound) {
                    ShowToast('Username already present, please try with different username!', TYPE_FAIL, INTERVAL, "", "");
                    setIsUsernamePresent(true);
                    setUserName("");
                }
                else {
                    setIsUsernamePresent(false);
                }
            }
        }
    }

    const changeEmployerUnit = (event) => {
        setEmployerUnit({ label: event.label, value: event.value });
    }

    const changeTrainingParnter = (event) => {
        setSelectedTrainingPartner({ label: event.label, value: event.value })
    }

    const userRoleChaneHandler = (event) => {
        setUserRole(event);
    };

    const cancelHandler = () => {
        props.history.push(
            `${isFromProfile ? "project-list" : "/user-page"}`
        );
    };

    const changeProgram = (event) => {
        console.log("partnerList", partnerList);
        if (event.label === "TIMES-PRO") {
            setSelectedTrainingPartner(null);
            setSetDisableTrainingPartner(true);
        } else {
            setSetDisableTrainingPartner(false);
        }

        setSelectedPartner({ label: event.label, value: event.value });
        setTrainingPartnerListComponent(event.label, partnerList);
    };

    const setTrainingPartnerListComponent = async (selectedPartner, list) => {
        let listComponent = [];
        list.forEach((item) => {
            if (item.partner_name === selectedPartner) {
                if (item.training_partner) {
                    listComponent.push({ label: item.training_partner, value: item._id })
                }
            }
        });
        setSetTrainingPartnerComponent(listComponent);
    }

    const changeCompany = (event) => {
        setSelectedEmployer({ label: event.label, value: event.value });
        setEmployerUnitListComponent(event);
    };

    const setEmployerUnitListComponent = (event) => {
        let list = [];
        employerList.forEach((item) => {
            if (event.label === item.employer_name) {
                list.push({ label: item.unit_name, value: item._id });
                setEmployerUnit(null);
            }

            if (list.length === 0) {
                setSetDisableEmployerUnit(true);
                setEmployerUnit(null);
            }
            else {
                setSetDisableEmployerUnit(false);
            }
        })
        setEmployerUnitComponent(list);
    }

    const handleProfileChange = (event) => {
        if (event.label === "Employer") {
            setSelectedEmployer(null);
            setEmployerUnit(null);
        }
        if (event.label === "Training Partner") {
            setSelectedPartner(null);
            setSelectedTrainingPartner(null);
        }
        setSelectProfile({ label: event.label, value: event.value });

        const findObject = roleListComponent.find((findItem) => findItem.label.toLocaleLowerCase() === event.label.toLocaleLowerCase());
        if (findObject) {
            setUserRole(findObject);
        }
    }

    const isFormValid = () => {
        let isValid = true;
        let error = {};

        if (!firstName) {
            isValid = false;
            error.firstName = "Please enter first name";
        }

        if (!lastName) {
            isValid = false;
            error.lastName = "Please Enter last name";
        }

        if (!emailId) {
            isValid = false;
            error.emailId = "Please enter email id";
        }

        if (emailId) {
            if (!emailPattern.test(emailId)) {
                isValid = false;
                error.emailId = "Please enter valid email address.";
            } else {
                if (!userId) {
                    const findUser = userList.find(
                        (findItem) =>
                            findItem.email_id.trim().toLowerCase() ===
                            emailId.trim().toLowerCase()
                    );
                    if (findUser) {
                        isValid = false;
                        error.emailId =
                            "Email Id already present, please try with different email id";
                    }
                }
            }
        }

        if (!phoneNumber) {
            isValid = false;
            error.phoneNumber = "Please enter phone number";
        }

        if (phoneNumber !== "undefined") {
            if (!PHONE_NUMBER_PATTERN.test(phoneNumber)) {
                isValid = false;
                error.phoneNumber = "Please enter valid phone number.";
            }
        }

        if (!userName) {
            isValid = false;
            error.userName = "Please enter username";
        } else {
            if (isUsernamePresent && userId === null) {
                isValid = false;
                error.userName = "Please enter different username";
            } else {
                if (!userId) {
                    const findUser = userList.find(
                        (findItem) =>
                            findItem.username.trim().toLowerCase() ===
                            userName.trim().toLowerCase()
                    );
                    if (findUser) {
                        isValid = false;
                        error.userName =
                            "Username already present, please enter different username";
                    }
                }
            }
        }

        if (!password) {
            isValid = false;
            error.password = "Pleae enter password";
        }

        if (password && userId === null) {
            if (!passwordMatchPattern.test(password)) {
                isValid = false;
                error.password = "Please enter valid password";
                ShowToast(
                    "Password must be minimum eight characters including one uppercase letter,\n one special character and alphanumeric characters",
                    TYPE_INFO,
                    INTERVAL,
                    props,
                    ""
                );
            }
        }

        if (!confirmPassword) {
            isValid = false;
            error.confirmPassword = "Please enter confirm password";
        }

        if (password !== confirmPassword) {
            isValid = false;
            error.confirmPassword =
                "Entered password and confirm password does not match";
        }

        if (!userRole) {
            isValid = false;
            error.userRole = "Please select user role";
        }

        if (
            selectedEmployer === null &&
            selectProfile &&
            selectProfile.label === "Employer"
        ) {
            isValid = false;
            error.selectedEmployerError = "Please select Employer";
        }

        if (employerUnit === null && setDisableEmployerUnit === false) {
            isValid = false;
            error.employerUnitError = "Please select the Employer unit";
        }

        if (
            selectedPartner === null &&
            selectProfile &&
            selectProfile.label === "Training Partner"
        ) {
            isValid = false;
            error.selectedPartnerError = "Please select the Project";
        }

        if (
            selectedTrainingPartner === null &&
            setDisableTrainingPartner === false
        ) {
            isValid = false;
            error.selectedTrainingPartnerError =
                "Please select the training partner";
        }

        setError(error);
        return isValid;
    };

    const createUserHandler = async (event) => {
        event.preventDefault();
        if (isFormValid()) {
            setIsLoading(true);
            const requestData = {
                userFirstName: firstName,
                userLastName: lastName,
                userEmailId: emailId,
                userPhoneNumber: phoneNumber,
                userName: userName.trim().toLowerCase(),
                userPassword: userId === null ? md5(password) : password,
                displayPass: CryptoJS.AES.encrypt(password, SECRET_KEY).toString(),
                userType: userType,
                userRole: userRole && userRole.value ? userRole.value : "",
                userSelectProfile: selectProfile && selectProfile.label ? selectProfile.label : null,
                userSelectedEmployer: selectProfile.label === "Employer" ? (selectedEmployer ? selectedEmployer.value : null) : null,
                userEmployerUnit: selectProfile.label === "Employer" ? (employerUnit ? employerUnit.value : null) : null,
                userSelectedTrainingPartner: selectProfile.label === "Training Partner" && selectedPartner.label !== "TIMES-PRO" ? (selectedTrainingPartner ? selectedTrainingPartner.value : null) : null,
                auditflag: auditflag,
                userId: userdetails ? userdetails._id : null
            }
            let userResponse = null;
            if (userId === null) {
                userResponse = await createUserCall({}, requestData);
            }
            else {
                userResponse = await UpdateUserCall({}, requestData, userId);
            }

            if (userResponse.statusCode === 200) {
                if (userId === null) {
                    ShowToast('User created Successfully', TYPE_SUCCESS, INTERVAL, props, `${isFromProfile ? "project-list" : "/user-page"}`);
                }
                else {
                    ShowToast('User updated Successfully', TYPE_SUCCESS, INTERVAL, props, `${isFromProfile ? "project-list" : "/user-page"}`);
                }
                props.history.push(
                    `${isFromProfile ? "project-list" : "/user-page"}`
                );
            }
        }
    }

    return (
        <>
            {
                isLoading ? (
                    <Spinner />
                ) : (
                    <div className="main-content">
                        <div className="back">
                            <ul className="breadcrumb1">
                                <li><a href="/user-page">User Master</a></li>
                                {
                                    userId === null ? (
                                        <li>Add New User</li>
                                    ) : (
                                        <li>Edit User</li>
                                    )
                                }
                            </ul>
                        </div>
                        <div className="add-user-wrapper">
                            <div className="mx-auto text-left border create-user-div">
                                <form onSubmit={createUserHandler} className="pt-1" autoComplete="off">
                                    <div className="user-icon-wrapper">
                                        <h4>{userId === null ? "Add New User" : "Edit User"}</h4>
                                        <i className={`${USER_ICON} list-table-icon`}></i>
                                    </div>

                                    <div className="row mt-0">
                                        <div className="input-label-group col-md-6">
                                            <label className="form-label">First Name <span className="text-danger">*</span></label>
                                            <input className="form-control brand-font p-3 placeholderColor add-user-input add-user-input-height" value={firstName} onChange={firstNameChangeHandler} placeholder="Enter First Name" />
                                            <div className="text-danger error-msg">
                                                {error.firstName}
                                            </div>
                                        </div>
                                        <div className="input-label-group col-md-6">
                                            <label className="form-label">Last Name <span className="text-danger">*</span></label>
                                            <input className="form-control brand-font p-3 placeholderColor add-user-input add-user-input-height" value={lastName} onChange={lastNameChangeHandler} placeholder="Enter Last Name" />
                                            <div className="text-danger error-msg">
                                                {error.lastName}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row mt-0">
                                        <div className="input-label-group col-md-6 email-input">
                                            <label className="form-label">Email Id <span className="text-danger">*</span></label>
                                            <input className="form-control brand-font p-3 placeholderColor add-user-input add-user-input-height lowercase-email" value={emailId} onChange={emailIdChangeHandler} placeholder="Enter Email Id" disabled={isFromProfile} onBlur={emailUniqueHandler} />
                                            <div className="text-danger error-msg">
                                                {error.emailId}
                                            </div>
                                        </div>
                                        <div className="input-label-group col-md-6">
                                            <label className="form-label">Phone Number <span className="text-danger">*</span></label>
                                            <input className="form-control brand-font p-3 placeholderColor add-user-input add-user-input-height" value={phoneNumber} onChange={phoneNumberChangeHandler} placeholder="Enter Phone Number" maxLength="10" />
                                            <div className="text-danger error-msg">
                                                {error.phoneNumber}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row mt-0">
                                        <div className="col-md-6">
                                            <div className="form-wrap">
                                                <label className="form-label-outside" htmlFor="general-information-skills">Select Profile</label>
                                                <div className="form-wrap-inner">
                                                    <Select
                                                        className={"add-user-input-height"}
                                                        placeholder={`Select Profile`}
                                                        options={profileOptions}
                                                        value={selectProfile}
                                                        onChange={handleProfileChange}
                                                        isSearchable={true}
                                                        isMulti={false}
                                                        isDisabled={isFromProfile}
                                                    />
                                                </div>
                                            </div>
                                            <div className="text-danger error-msg">
                                                {error.selectProfileError}
                                            </div>
                                        </div>
                                    </div>
                                    {selectProfile.label === "Employer" && (
                                        <div className="row">
                                            <div className="input-label-group col-md-6">
                                                <label className="form-label">Select Company <span className="text-danger">*</span></label>
                                                <div className="form-wrap-inner">
                                                    <Select
                                                        placeholder={`Select Company`}
                                                        value={selectedEmployer}
                                                        onChange={changeCompany}
                                                        options={employerListComponent}
                                                        isSearchable={true}
                                                        isMulti={false}
                                                        isDisabled={isFromProfile}
                                                    />
                                                </div>
                                                <div className="text-danger error-msg">
                                                    {error.selectedEmployerError}
                                                </div>
                                            </div>
                                            <div className="input-label-group col-md-6">
                                                <label className="form-label">Select Employer Unit <span className="text-danger">*</span></label>
                                                <div className="form-wrap-inner">
                                                    <Select
                                                        placeholder={`Select Employer Unit`}
                                                        value={employerUnit}
                                                        onChange={changeEmployerUnit}
                                                        options={employerUnitComponent}
                                                        isSearchable={true}
                                                        isMulti={false}
                                                        isDisabled={setDisableEmployerUnit}
                                                    />
                                                </div>
                                                <div className="text-danger error-msg">
                                                    {error.employerUnitError}
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                    {selectProfile.label === "Training Partner" && (
                                        <div className="row">
                                            <div className="input-label-group col-md-6">
                                                <label className="form-label">Select Program <span className="text-danger">*</span></label>
                                                <div className="form-wrap-inner">
                                                    <Select
                                                        placeholder={`Select Program`}
                                                        value={selectedPartner}
                                                        onChange={changeProgram}
                                                        options={selectedPartnerList}
                                                        isSearchable={true}
                                                        isMulti={false}
                                                        isDisabled={isFromProfile}
                                                    />
                                                </div>
                                                <div className="text-danger error-msg">
                                                    {error.selectedPartnerError}
                                                </div>
                                            </div>
                                            <div className="input-label-group col-md-6">
                                                <label className="form-label">Select Training Partner <span className="text-danger">*</span> </label>
                                                <div className="form-wrap-inner">
                                                    <Select
                                                        placeholder={`Select  Training Partner`}
                                                        value={selectedTrainingPartner}
                                                        onChange={changeTrainingParnter}
                                                        options={setTrainingPartnerComponent}
                                                        isSearchable={true}
                                                        isDisabled={setDisableTrainingPartner}
                                                    />
                                                </div>
                                                <div className="text-danger error-msg">
                                                    {error.selectedTrainingPartnerError}
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                    <div className="row">
                                        <div className="input-label-group col-md-6 email-input">
                                            <label className="form-label">User Name <span className="text-danger">*</span></label>
                                            <input className="form-control brand-font p-3 placeholderColor add-user-input add-user-input-height" value={userName} onChange={userNameChangeHandler} onBlur={usernameUniqueHandler} placeholder="Enter User Name" disabled={isFromProfile} />
                                            <div className="text-danger error-msg">
                                                {error.userName}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row password-row">
                                        <div className="input-label-group col-md-6">
                                            <label className="form-label">Password <span className="text-danger">*</span></label>
                                            <div className="password-input-div">
                                                {
                                                    showPassword === true ? (<>
                                                        <input type="text" className="form-control brand-font p-3 placeholderColor add-user-input add-user-input-height" value={password} onChange={passwordChangehandler} placeholder="Enter Password" disabled={userId ? true : false} />
                                                        <i className={`${EYE_SLASH_ICON} eye-icon-class-for-password`} onClick={handleShowPasswordClick} title="View password"></i>
                                                    </>) : (<>
                                                        <input type="password" className="form-control brand-font p-3 placeholderColor add-user-input add-user-input-height" value={password} onChange={passwordChangehandler} placeholder="Enter Password" disabled={userId ? true : false} />
                                                        <i className={`${EYE_ICON} eye-icon-class-for-password`} onClick={handleShowPasswordClick} title="View password"></i>
                                                    </>)
                                                }
                                            </div>
                                            <div className="text-danger error-msg">
                                                {error.password}
                                            </div>
                                        </div>
                                        <div className="input-label-group col-md-6">
                                            <label className="form-label">Confirm Password <span className="text-danger">*</span></label>
                                            <div className="password-input-div">
                                                {
                                                    showConfirmPassword === true ? (<>
                                                        <input type="text" className="form-control brand-font p-3 placeholderColor add-user-input add-user-input-height text-transform-none" value={confirmPassword} onChange={confirmPasswordChangehandler} placeholder="Confirm Password" disabled={userId ? true : false} />
                                                        <i className={`${EYE_SLASH_ICON} eye-icon-class-for-password`} onClick={handleShowConfirmPasswordClick} title="View Password"></i>
                                                    </>) : (<>
                                                        <input type="password" className="form-control brand-font p-3 placeholderColor add-user-input add-user-input-height text-transform-none" value={confirmPassword} onChange={confirmPasswordChangehandler} placeholder="Confirm Password" disabled={userId ? true : false} />
                                                        <i className={`${EYE_ICON} eye-icon-class-for-password`} onClick={handleShowConfirmPasswordClick} title="View Password"></i>
                                                    </>)
                                                }
                                            </div>
                                            <div className="text-danger error-msg">
                                                {error.confirmPassword}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row mt-0">
                                        <div className="col-md-6">
                                            <div className="form-wrap">
                                                <label className="form-label-outside" htmlFor="general-information-skills">User Role </label>
                                                <div className="form-wrap-inner">
                                                    <Select
                                                        placeholder={`Select User Role`}
                                                        value={userRole}
                                                        onChange={userRoleChaneHandler}
                                                        options={roleListComponent}
                                                        isSearchable={true}
                                                        isDisabled={isFromProfile}
                                                    />
                                                </div>
                                            </div>
                                            <div className="text-danger error-msg">
                                                {error.userRole}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row mt-0 mt-4 mb-5 display-inline">
                                        <div className="form-button-div">
                                            <button className="brand-button" onClick={createUserHandler}>{userId ? "Update" : "Create"}</button>
                                            <button className="cancel_button ml-5" onClick={cancelHandler}>Cancel</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div className="row dummy_row"></div>
                    </div>
                )
            }
        </>
    );
}

export default CreateUserPage;